import { Obj3d } from './obj3d';
import { Scheme3dComponent } from './scheme3d.component';
import { MeshPhongMaterial } from 'three';
import { DrawSatelite3d } from '../satelite3d/draw-satelite3d';
import { ComputeSatelite3d } from '../satelite3d/compute-satelite3d';

export class Puerta3d extends Obj3d {

	constructor(path: string, debug = false) {
		super(path, debug);
		this._data = {
			PBatLig100x100: { estado: 0, archivo: 'PBLigera_1x1', carpeta: 'PBLigera', mesh: undefined, length: 1.171 },
			PBatLig100x120: { estado: 0, archivo: 'PBLigera_1x12', carpeta: 'PBLigera', mesh: undefined, length: 1.171 },
			PBatLig100x150: { estado: 0, archivo: 'PBLigera_1x15', carpeta: 'PBLigera', mesh: undefined, length: 1.171 },
			PBatLig100x180: { estado: 0, archivo: 'PBLigera_1x18', carpeta: 'PBLigera', mesh: undefined, length: 1.171 },
			PBatLig100x200: { estado: 0, archivo: 'PBLigera_1x2', carpeta: 'PBLigera', mesh: undefined, length: 1.171 },
			PBatLig200x100: { estado: 0, archivo: 'PBLigera_2x1', carpeta: 'PBLigera', mesh: undefined, length: 2.192 },
			PBatLig200x120: { estado: 0, archivo: 'PBLigera_2x12', carpeta: 'PBLigera', mesh: undefined, length: 2.2 },
			PBatLig200x150: { estado: 0, archivo: 'PBLigera_2x15', carpeta: 'PBLigera', mesh: undefined, length: 2.2 },
			PBatLig200x180: { estado: 0, archivo: 'PBLigera_2x18', carpeta: 'PBLigera', mesh: undefined, length: 2.2 },
			PBatLig200x200: { estado: 0, archivo: 'PBLigera_2x2', carpeta: 'PBLigera', mesh: undefined, length: 2.192 },
			PBatLig300x100: { estado: 0, archivo: 'PBLigera_3x1', carpeta: 'PBLigera', mesh: undefined, length: 3.1 },
			PBatLig300x120: { estado: 0, archivo: 'PBLigera_3x12', carpeta: 'PBLigera', mesh: undefined, length: 3.2 },
			PBatLig300x150: { estado: 0, archivo: 'PBLigera_3x15', carpeta: 'PBLigera', mesh: undefined, length: 3.2 },
			PBatLig300x180: { estado: 0, archivo: 'PBLigera_3x18', carpeta: 'PBLigera', mesh: undefined, length: 3.2 },
			PBatLig300x200: { estado: 0, archivo: 'PBLigera_3x2', carpeta: 'PBLigera', mesh: undefined, length: 3.2 },
			PBatLig400x100: { estado: 0, archivo: 'PBLigera_4x1', carpeta: 'PBLigera', mesh: undefined, length: 4.1 },
			PBatLig400x120: { estado: 0, archivo: 'PBLigera_4x12', carpeta: 'PBLigera', mesh: undefined, length: 4.21 },
			PBatLig400x150: { estado: 0, archivo: 'PBLigera_4x15', carpeta: 'PBLigera', mesh: undefined, length: 4.21 },
			PBatLig400x180: { estado: 0, archivo: 'PBLigera_4x18', carpeta: 'PBLigera', mesh: undefined, length: 4.21 },
			PBatLig400x200: { estado: 0, archivo: 'PBLigera_4x2', carpeta: 'PBLigera', mesh: undefined, length: 4.21 },
			PBatLig500x200: { estado: 0, archivo: 'PBLigera_5x2', carpeta: 'PBLigera', mesh: undefined, length: 5.28 },			
			PBatLig600x200: { estado: 0, archivo: 'PBLigera_6x2', carpeta: 'PBLigera', mesh: undefined, length: 6.2 },

			// #ESPRIVISA-55 PUERTAS BATIENTE MEDIUM
			PBatMedium100x100:{ estado:0, archivo: 'PBMedium_1x1', carpeta: 'PBMedium', mesh: undefined, length:1.171},
			PBatMedium100x120:{ estado:0, archivo: 'PBMedium_1x12', carpeta: 'PBMedium', mesh: undefined, length:1.171},
			PBatMedium100x150:{ estado:0, archivo: 'PBMedium_1x15', carpeta: 'PBMedium', mesh: undefined, length:1.171},
			PBatMedium100x180:{ estado:0, archivo: 'PBMedium_1x18', carpeta: 'PBMedium', mesh: undefined, length:1.171},
			PBatMedium100x200:{ estado:0, archivo: 'PBMedium_1x2', carpeta: 'PBMedium', mesh: undefined, length:1.171},
			PBatMedium300x120:{ estado:0, archivo: 'PBMedium_3x12', carpeta: 'PBMedium', mesh: undefined, length:3.2},
			PBatMedium300x150:{ estado:0, archivo: 'PBMedium_3x15', carpeta: 'PBMedium', mesh: undefined, length:3.2},
			PBatMedium300x180:{ estado:0, archivo: 'PBMedium_3x18', carpeta: 'PBMedium', mesh: undefined, length:3.2},
			PBatMedium300x200:{ estado:0, archivo: 'PBMedium_3x2', carpeta: 'PBMedium', mesh: undefined, length:3.2},
			PBatMedium400x150:{ estado:0, archivo: 'PBMedium_4x15', carpeta: 'PBMedium', mesh: undefined, length:4.21},
			PBatMedium400x200:{ estado:0, archivo: 'PBMedium_4x2', carpeta: 'PBMedium', mesh: undefined, length:4.21},


			// #ESPRIVISA-44
			PBatFue100x100: { estado: 0, archivo: 'PBFuerte_1x1', carpeta: 'PBFuerte', mesh: undefined, length: 1.00 },
			PBatFue100x120: { estado: 0, archivo: 'PBFuerte_1x12', carpeta: 'PBFuerte', mesh: undefined, length: 1.12 },
			PBatFue100x150: { estado: 0, archivo: 'PBFuerte_1x15', carpeta: 'PBFuerte', mesh: undefined, length: 1.22 },
			PBatFue100x180: { estado: 0, archivo: 'PBFuerte_1x18', carpeta: 'PBFuerte', mesh: undefined, length: 1.22 },
			PBatFue100x200: { estado: 0, archivo: 'PBFuerte_1x2', carpeta: 'PBFuerte', mesh: undefined, length: 1.22 },
			PBatFue200x100: { estado: 0, archivo: 'PBFuerte_2x1', carpeta: 'PBFuerte', mesh: undefined, length: 2.1 },
			PBatFue200x120: { estado: 0, archivo: 'PBFuerte_2x12', carpeta: 'PBFuerte', mesh: undefined, length: 2.12 },
			PBatFue200x150: { estado: 0, archivo: 'PBFuerte_2x15', carpeta: 'PBFuerte', mesh: undefined, length: 2.15 },
			PBatFue200x180: { estado: 0, archivo: 'PBFuerte_2x18', carpeta: 'PBFuerte', mesh: undefined, length: 2.18 },
			PBatFue200x200: { estado: 0, archivo: 'PBFuerte_2x2', carpeta: 'PBFuerte', mesh: undefined, length: 2.2 },
			PBatFue300x100: { estado: 0, archivo: 'PBFuerte_3x1', carpeta: 'PBFuerte', mesh: undefined, length: 3.22 },
			PBatFue300x120: { estado: 0, archivo: 'PBFuerte_3x12', carpeta: 'PBFuerte', mesh: undefined, length: 3.22 },
			PBatFue300x150: { estado: 0, archivo: 'PBFuerte_3x15', carpeta: 'PBFuerte', mesh: undefined, length: 3.22 },
			PBatFue300x180: { estado: 0, archivo: 'PBFuerte_3x18', carpeta: 'PBFuerte', mesh: undefined, length: 3.22 },
			PBatFue300x200: { estado: 0, archivo: 'PBFuerte_3x2', carpeta: 'PBFuerte', mesh: undefined, length: 3.22 },
			PBatFue400x100: { estado: 0, archivo: 'PBFuerte_4x1', carpeta: 'PBFuerte', mesh: undefined, length: 4.2 },
			PBatFue400x120: { estado: 0, archivo: 'PBFuerte_4x12', carpeta: 'PBFuerte', mesh: undefined, length: 4.2 },
			PBatFue400x150: { estado: 0, archivo: 'PBFuerte_4x15', carpeta: 'PBFuerte', mesh: undefined, length: 4.2 },
			PBatFue400x180: { estado: 0, archivo: 'PBFuerte_4x18', carpeta: 'PBFuerte', mesh: undefined, length: 4.2 },
			PBatFue400x200: { estado: 0, archivo: 'PBFuerte_4x2', carpeta: 'PBFuerte', mesh: undefined, length: 4.2 },
			PBatFue500x200: { estado: 0, archivo: 'PBFuerte_5x2', carpeta: 'PBFuerte', mesh: undefined, length: 5.32 },
			PBatFue600x200: { estado: 0, archivo: 'PBFuerte_6x2', carpeta: 'PBFuerte', mesh: undefined, length: 6.22 },


			//# ESPRIVISA-46
			PBatUltra100x200: { estado: 0, archivo: 'PBUltra_1x2', carpeta: 'PBUltra', mesh: undefined, length: 1.23 },
			PBatUltra100x150: { estado: 0, archivo: 'PBUltra_1x15', carpeta: 'PBUltra', mesh: undefined, length: 1.22 },
			PBatUltra300x200: { estado: 0, archivo: 'PBUltra_3x2', carpeta: 'PBUltra', mesh: undefined, length: 3.2 },
			PBatUltra400x200: { estado: 0, archivo: 'PBUltra_4x2', carpeta: 'PBUltra', mesh: undefined, length: 4.3 },			
			

			PBatDecor100x200: { estado: 0, archivo: 'PBDecor_1x2', carpeta: 'PBDecor', mesh: undefined, length: 1.25 },
			PBatDecor400x200: { estado: 0, archivo: 'PBDecor_4x2', carpeta: 'PBDecor', mesh: undefined, length: 4.3 },
			PBatDecor100x150: { estado: 0, archivo: 'PBDecor_1x15', carpeta: 'PBDecor', mesh: undefined, length: 1.22 },
			PBatDecor300x200: { estado: 0, archivo: 'PBDecor_3x2', carpeta: 'PBDecor', mesh: undefined, length: 3.22 },

			PBatNove100x150: { estado: 0, archivo: 'PBNove_1x15', carpeta: 'PBNove', mesh: undefined, length: 1.22 },
			PBatNove100x200: { estado: 0, archivo: 'PBNove_1x2', carpeta: 'PBNove', mesh: undefined, length: 1.22 },
			PBatNove300x200: { estado: 0, archivo: 'PBNove_3x2', carpeta: 'PBNove', mesh: undefined, length: 3.47 },
			PBatNove400x200: { estado: 0, archivo: 'PBNove_4x2', carpeta: 'PBNove', mesh: undefined, length: 4.3 },

			PDesClassic4x2: { estado: 0, archivo: 'PDClassic_4x2', carpeta: 'PDClassic', mesh: undefined, length: 4.73 },
			PDesClassic5x2: { estado: 0, archivo: 'PDClassic_5x2', carpeta: 'PDClassic', mesh: undefined, length: 5.74 },
			PDesClassic6x2: { estado: 0, archivo: 'PDClassic_6x2', carpeta: 'PDClassic', mesh: undefined, length: 7 },
			PDesClassic7x2: { estado: 0, archivo: 'PDClassic_7x2', carpeta: 'PDClassic', mesh: undefined, length: 7.86 },
			PDesClassic8x2: { estado: 0, archivo: 'PDClassic_8x2', carpeta: 'PDClassic', mesh: undefined, length: 8.75 },
			PDesClassic9x2: { estado: 0, archivo: 'PDClassic_9x2', carpeta: 'PDClassic', mesh: undefined, length: 9.87 },
			PDesClassic10x2: { estado: 0, archivo: 'PDClassic_10x2', carpeta: 'PDClassic', mesh: undefined, length: 10.9 },
			PDesClassic11x2: { estado: 0, archivo: 'PDClassic_11x2', carpeta: 'PDClassic', mesh: undefined, length: 11.89 },
			PDesClassic12x2: { estado: 0, archivo: 'PDClassic_12x2', carpeta: 'PDClassic', mesh: undefined, length: 12.88 },
			PDesClassic13x2: { estado: 0, archivo: 'PDClassic_13x2', carpeta: 'PDClassic', mesh: undefined, length: 13.88 },
			PDesClassic14x2: { estado: 0, archivo: 'PDClassic_14x2', carpeta: 'PDClassic', mesh: undefined, length: 14.73 },

			PDesCalitax4x2: { estado: 0, archivo: 'PDCalitax_4x2', carpeta: 'PDCalitax', mesh: undefined, length: 4.73 },
			PDesCalitax5x2: { estado: 0, archivo: 'PDCalitax_5x2', carpeta: 'PDCalitax', mesh: undefined, length: 5.74 },
			PDesCalitax6x2: { estado: 0, archivo: 'PDCalitax_6x2', carpeta: 'PDCalitax', mesh: undefined, length: 7 },
			PDesCalitax7x2: { estado: 0, archivo: 'PDCalitax_7x2', carpeta: 'PDCalitax', mesh: undefined, length: 7.86 },
			PDesCalitax8x2: { estado: 0, archivo: 'PDCalitax_8x2', carpeta: 'PDCalitax', mesh: undefined, length: 8.75 },
			PDesCalitax9x2: { estado: 0, archivo: 'PDCalitax_9x2', carpeta: 'PDCalitax', mesh: undefined, length: 9.87 },
			PDesCalitax10x2: { estado: 0, archivo: 'PDCalitax_10x2', carpeta: 'PDCalitax', mesh: undefined, length: 10.89 },
			PDesCalitax11x2: { estado: 0, archivo: 'PDCalitax_11x2', carpeta: 'PDCalitax', mesh: undefined, length: 11.89 },
			PDesCalitax12x2: { estado: 0, archivo: 'PDCalitax_12x2', carpeta: 'PDCalitax', mesh: undefined, length: 12.88 },
			PDesCalitax13x2: { estado: 0, archivo: 'PDCalitax_13x2', carpeta: 'PDCalitax', mesh: undefined, length: 13.88 },
			PDesCalitax14x2: { estado: 0, archivo: 'PDCalitax_14x2', carpeta: 'PDCalitax', mesh: undefined, length: 14.73 },

			PDesUltra4x2: { estado: 0, archivo: 'PDUltra_4x2', carpeta: 'PDUltra', mesh: undefined, length: 4.73 },
			PDesUltra5x2: { estado: 0, archivo: 'PDUltra_5x2', carpeta: 'PDUltra', mesh: undefined, length: 5.73 },
			PDesUltra6x2: { estado: 0, archivo: 'PDUltra_6x2', carpeta: 'PDUltra', mesh: undefined, length: 7 },
			PDesUltra7x2: { estado: 0, archivo: 'PDUltra_7x2', carpeta: 'PDUltra', mesh: undefined, length: 7.79 },
			PDesUltra8x2: { estado: 0, archivo: 'PDUltra_8x2', carpeta: 'PDUltra', mesh: undefined, length: 8.76 },
			PDesUltra9x2: { estado: 0, archivo: 'PDUltra_9x2', carpeta: 'PDUltra', mesh: undefined, length: 9.9 },
			PDesUltra10x2: { estado: 0, archivo: 'PDUltra_10x2', carpeta: 'PDUltra', mesh: undefined, length: 10.87 },
			PDesUltra11x2: { estado: 0, archivo: 'PDUltra_11x2', carpeta: 'PDUltra', mesh: undefined, length: 11.88 },
			PDesUltra12x2: { estado: 0, archivo: 'PDUltra_12x2', carpeta: 'PDUltra', mesh: undefined, length: 12.87 },
			PDesUltra13x2: { estado: 0, archivo: 'PDUltra_13x2', carpeta: 'PDUltra', mesh: undefined, length: 13.93 },
			PDesUltra14x2: { estado: 0, archivo: 'PDUltra_14x2', carpeta: 'PDUltra', mesh: undefined, length: 14.75 },

			PDesDecor4x2: { estado: 0, archivo: 'PDDecor_4x2', carpeta: 'PDDecor', mesh: undefined, length: 4.73 },
			PDesDecor5x2: { estado: 0, archivo: 'PDDecor_5x2', carpeta: 'PDDecor', mesh: undefined, length: 5.74 },
			PDesDecor6x2: { estado: 0, archivo: 'PDDecor_6x2', carpeta: 'PDDecor', mesh: undefined, length: 7 },
			PDesDecor7x2: { estado: 0, archivo: 'PDDecor_7x2', carpeta: 'PDDecor', mesh: undefined, length: 7.8 },
			PDesDecor8x2: { estado: 0, archivo: 'PDDecor_8x2', carpeta: 'PDDecor', mesh: undefined, length: 8.98 },
			PDesDecor9x2: { estado: 0, archivo: 'PDDecor_9x2', carpeta: 'PDDecor', mesh: undefined, length: 9.93 },
			PDesDecor10x2: { estado: 0, archivo: 'PDDecor_10x2', carpeta: 'PDDecor', mesh: undefined, length: 10.89 },
			PDesDecor11x2: { estado: 0, archivo: 'PDDecor_11x2', carpeta: 'PDDecor', mesh: undefined, length: 11.99 },
			PDesDecor12x2: { estado: 0, archivo: 'PDDecor_12x2', carpeta: 'PDDecor', mesh: undefined, length: 13.09 },
			PDesDecor13x2: { estado: 0, archivo: 'PDDecor_13x2', carpeta: 'PDDecor', mesh: undefined, length: 14.04 },
			PDesDecor14x2: { estado: 0, archivo: 'PDDecor_14x2', carpeta: 'PDDecor', mesh: undefined, length: 14.80 },

			PDesNove4x2: { estado: 0, archivo: 'PDNove_4x2', carpeta: 'PDNove', mesh: undefined, length: 4.73 },
			PDesNove5x2: { estado: 0, archivo: 'PDNove_5x2', carpeta: 'PDNove', mesh: undefined, length: 5.8 },
			PDesNove6x2: { estado: 0, archivo: 'PDNove_6x2', carpeta: 'PDNove', mesh: undefined, length: 6.8 },
			PDesNove7x2: { estado: 0, archivo: 'PDNove_7x2', carpeta: 'PDNove', mesh: undefined, length: 7.8 },
			PDesNove8x2: { estado: 0, archivo: 'PDNove_8x2', carpeta: 'PDNove', mesh: undefined, length: 8.88 },
			PDesNove9x2: { estado: 0, archivo: 'PDNove_9x2', carpeta: 'PDNove', mesh: undefined, length: 9.71 },
			PDesNove10x2: { estado: 0, archivo: 'PDNove_10x2', carpeta: 'PDNove', mesh: undefined, length: 10.59 },
			PDesNove11x2: { estado: 0, archivo: 'PDNove_11x2', carpeta: 'PDNove', mesh: undefined, length: 11.53 },
			PDesNove12x2: { estado: 0, archivo: 'PDNove_12x2', carpeta: 'PDNove', mesh: undefined, length: 12.59 },
			PDesNove13x2: { estado: 0, archivo: 'PDNove_13x2', carpeta: 'PDNove', mesh: undefined, length: 13.47 },
			PDesNove14x2: { estado: 0, archivo: 'PDNove_14x2', carpeta: 'PDNove', mesh: undefined, length: 14.80 },

			//PUERTA BATIENTE NATURE ESPRIVISA-64
            PBatNature100x150: { estado: 0, archivo: 'PBNature_1x15', carpeta: 'PBNature', mesh: undefined, length: 1.22 },
            PBatNature100x200: { estado: 0, archivo: 'PBNature_1x2', carpeta: 'PBNature', mesh: undefined, length: 1.171 },
            PBatNature300x200: { estado: 0, archivo: 'PBNature_3x2', carpeta: 'PBNature', mesh: undefined, length: 3.2 },
            PBatNature400x200: { estado: 0, archivo: 'PBNature_4x2', carpeta: 'PBNature', mesh: undefined, length: 4.21 },


			//PUERTA DESLIZANTE NATURE ESPRIVISA-64

			PDNature4x2: { estado: 0, archivo: 'PDNature_4x2', carpeta: 'PDNature', mesh: undefined, length: 4.73 },
			PDNature5x2: { estado: 0, archivo: 'PDNature_5x2', carpeta: 'PDNature', mesh: undefined, length: 5.74 },
			PDNature6x2: { estado: 0, archivo: 'PDNature_6x2', carpeta: 'PDNature', mesh: undefined, length: 7 },
			PDNature7x2: { estado: 0, archivo: 'PDNature_7x2', carpeta: 'PDNature', mesh: undefined, length: 7.8 },
			PDNature8x2: { estado: 0, archivo: 'PDNature_8x2', carpeta: 'PDNature', mesh: undefined, length: 8.98 },
			PDNature9x2: { estado: 0, archivo: 'PDNature_9x2', carpeta: 'PDNature', mesh: undefined, length: 9.93 },
			PDNature10x2: { estado: 0, archivo: 'PDNature_10x2', carpeta: 'PDNature', mesh: undefined, length: 10.89 },
			PDNature11x2: { estado: 0, archivo: 'PDNature_11x2', carpeta: 'PDNature', mesh: undefined, length: 11.99 },
			PDNature12x2: { estado: 0, archivo: 'PDNature_12x2', carpeta: 'PDNature', mesh: undefined, length: 13.09 },
			PDNature13x2: { estado: 0, archivo: 'PDNature_13x2', carpeta: 'PDNature', mesh: undefined, length: 14.07 },
			PDNature14x2: { estado: 0, archivo: 'PDNature_14x2', carpeta: 'PDNature', mesh: undefined, length: 14.80 },

		};
	}

	// ##### Clona la puerta y sus materiales asignandole el color DrawSatelite3d.
	public cloneDoorSatelite(type: string, satelite: DrawSatelite3d) {
		let data = this._data[type];

		// No seguir si no existe la puerta.
		if (!data || !data.mesh) return undefined;

		// Conar la puerta.
		let door = data.mesh.clone();

		// ####### Configurar la puerta.
		// Dirección del perímetro.
		door.scale.z = satelite.DTPerimeterActual.direction;

		// Nombre, útil para identificar en debugación.
		door.name = 'door' + satelite.DTNamePerTramo + satelite.DTCountDoor++;

		// Reiniciar LUX ANUDADA.
		satelite.DTMetersLUXAnudada = 0;

		// Cambiar el color, solo si es necesario.
		if (satelite.DTHasColor) {
			// Cache de materiales para evitar repeticiones.
			let cache = {
				matCER: undefined,
				matPAS: undefined,
				matMUE: undefined,
				matBIS: undefined,
				matTRA: undefined
			};

			for (let obj of door.children) {
				if (obj.isMesh) {
					// Le propiedad material del objeto mesh de THREE puede ser un objeto o array de objetos.
					// Lamentable error de optimización ya que obliga a comprobar que viene.
					if (Array.isArray(obj.material)) {
						for (let mat = 0; mat < obj.material.length; mat++) {
							obj.material[mat] = this.__setMaterial(obj.material[mat], satelite.datasSatelite.ColorNeutro, cache);
						}
					} else {
						obj.material = this.__setMaterial(obj.material, satelite.datasSatelite.ColorNeutro, cache);
					}
				}
			}
		}
		return door;
	}

	// ##### Clona la puerta y sus materiales asignandole el color DrawSatelite3d.
	public cloneDoorSateliteData(type: string, satelite: ComputeSatelite3d) {
		let data = this._data[type];

		// No seguir si no existe la puerta.
		if (!data || !data.mesh) return undefined;

		// Conar la puerta.
		let door = data.mesh.clone();

		// ####### Configurar la puerta.
		// Dirección del perímetro.
		door.scale.z = satelite.DTPerimeterActual.direction;

		// Nombre, útil para identificar en debugación.
		door.name = 'door' + satelite.DTNamePerTramo + satelite.DTCountDoor++;

		// Reiniciar LUX ANUDADA.
		satelite.DTMetersLUXAnudada = 0;

		/*// Cambiar el color, solo si es necesario.
		if (satelite.DTHasColor) {
			// Cache de materiales para evitar repeticiones.
			let cache = {
				matCER: undefined,
				matPAS: undefined,
				matMUE: undefined,
				matBIS: undefined,
				matTRA: undefined
			};

			for (let obj of door.children) {
				if (obj.isMesh) {
					// Le propiedad material del objeto mesh de THREE puede ser un objeto o array de objetos.
					// Lamentable error de optimización ya que obliga a comprobar que viene.
					if (Array.isArray(obj.material)) {
						for (let mat = 0; mat < obj.material.length; mat++) {
							obj.material[mat] = this.__setMaterial(obj.material[mat], satelite.datasSatelite.ColorNeutro, cache);
						}
					} else {
						obj.material = this.__setMaterial(obj.material, satelite.datasSatelite.ColorNeutro, cache);
					}
				}
			}
		}*/
		return door;
	}

	// ##### Clona la puerta y sus materiales asignandole el color.
	public cloneDoor(type: string, scheme3d: Scheme3dComponent, magnitudActual: number) {
		let data = this._data[type];

		// No seguir si no existe la puerta.
		if (!data || !data.mesh) return undefined;

		// Clonar la puerta.
		let door = data.mesh.clone();

		// ####### Configurar la puerta.
		// Dirección del perímetro.
		door.scale.z = scheme3d.DTPerimeterActual.direction;

		// Nombre, útil para identificar en debugación.
		door.name = 'door' + scheme3d.DTNamePerTramo + scheme3d.DTCountDoor++;

		// Situar en el mundo 3D.
		door.position.x = magnitudActual;
		door.position.y = 0;
		console.log("Se introduce la puerta ",door.position.x)

		// Insertar en la escena.
		scheme3d.DTRootTramo.add(door);

		// Reiniciar LUX ANUDADA.
		scheme3d.DTMetersLUXAnudada = 0;

		// Cambiar el color, solo si es necesario.
		if (scheme3d.DTHasColor) {
			// Cache de materiales para evitar repeticiones.
			let cache = {
				matCER: undefined,
				matPAS: undefined,
				matMUE: undefined,
				matBIS: undefined,
				matTRA: undefined
			};

			for (let obj of door.children) {
				if (obj.isMesh) {
					// Le propiedad material del objeto mesh de THREE puede ser un objeto o array de objetos.
					// Lamentable error de optimización ya que obliga a comprobar que viene.
					if (Array.isArray(obj.material)) {
						for (let mat = 0; mat < obj.material.length; mat++) {
							obj.material[mat] = this.__setMaterial(obj.material[mat], scheme3d.gestor.ColorNeutro, cache);
						}
					} else {
						obj.material = this.__setMaterial(obj.material, scheme3d.gestor.ColorNeutro, cache);
					}
				}
			}
		}

		return door;
	}

	// ##### Método necesario debido a la mala optimización de la propiedad mesh.material.
	private __setMaterial(material: MeshPhongMaterial, neutro: MeshPhongMaterial, cache: any) {
		// Solo asignar material neutro.
		if (material.name.startsWith('COL_Neutro') || material.name.startsWith('Color_Gal')) {
			material = neutro;
		}
		// Cerradura, tiene textura.
		else if (material.name.startsWith('CER_')) {
			if (!cache.matCER) {
				cache.matCER = material.clone();
				cache.matCER.color.set(neutro.color);
			}
			material = cache.matCER;
		}
		// Pasador, tiene textura.
		else if (material.name.startsWith('PAS_')) {
			if (!cache.matPAS) {
				cache.matPAS = material.clone();
				cache.matPAS.color.set(neutro.color);
			}
			material = cache.matPAS;
		}
		// Muelle de la bisagra ligera, tiene textura.
		else if (material.name.startsWith('MUE_')) {
			if (!cache.matMUE) {
				cache.matMUE = material.clone();
				cache.matMUE.color.set(neutro.color);
			}
			material = cache.matMUE;
		}
		// Bisagra, tiene textura.
		else if (material.name.startsWith('BIS_')) {
			if (!cache.matBIS) {
				cache.matBIS = material.clone();
				cache.matBIS.color.set(neutro.color);
			}
			material = cache.matBIS;
		}
		// Bastidor, tiene textura.
		else if (material.name.startsWith('TRA_')) {
			if (!cache.matTRA) {
				cache.matTRA = material.clone();
				cache.matTRA.color.set(neutro.color);
			}
			material = cache.matTRA;
		}
		return material;
	}

}


